import { cssModules } from '@skyscanner-internal/backpack-web/bpk-react-utils';
import { usePageContext } from '@web-platform/shared-travel-tools-data-access-frontend';
import { generateTrackingAttributes } from '@web-platform/shared-travel-tools-utils-frontend';
import { AppCard } from '@web-platform/travel-tools-home-ui';

import { MBD_ITEMS, MBD_TYPE } from '../utils/meaningful-behaviour-data';

import type { AppCardProps } from '../utils/cards';

import STYLES from './CardGrid.module.scss';

const cls = cssModules(STYLES);

type Props = {
  cards: AppCardProps[];
};

export const CardGrid = ({ cards }: Props) => {
  const { isLoggedIn, locale, market } = usePageContext();
  const cfg = MBD_ITEMS[MBD_TYPE.TRAVEL_TOOLS_APP_CARD];

  return (
    <section className={cls('cardGrid')}>
      <ul className={cls('cardGridInner')}>
        {cards.map((card, index) => {
          const trackingAttrs = generateTrackingAttributes(
            `${cfg.id}_${card.id}_${index + 1}`,
            cfg.name,
            {
              tool_id: card.id,
              category: card.categoryId,
              position: index + 1,
              locale,
              market,
              is_logged_in: isLoggedIn,
            },
          );

          return (
            <li key={card.id} className={cls('cardGridItem')}>
              <AppCard
                category={card.category}
                id={card.id}
                ctaLabel={card.ctaLabel}
                description={card.description}
                href={card.href}
                name={card.name}
                {...trackingAttrs}
              />
            </li>
          );
        })}
      </ul>
    </section>
  );
};
